module.exports = __webpack_public_path__ + "img/itjianli.c57050d1.png";